<template>
  <div>
    <div class="flex progress_box mar_top_20">
      <div class="progress_one">
        <div class="study_text">已规律学习</div>
        <div class="flex study_days FlexjustifyEnd Flexalign">
          <div class="days_value">{{ learnedDay }}</div>
          <div class="mar_left_10 mar_top_10">天</div>
        </div>
      </div>
      <div class="progress_one mar_left_20">
        <div class="study_text">还需学习</div>
        <div class="flex study_days FlexjustifyEnd Flexalign">
          <div class="days_value">{{ monthDay - learnedDay }}</div>
          <div class="mar_left_10 mar_top_10">天</div>
        </div>
      </div>
    </div>
    <div class="flex Flexalign FlexBetween charts_top mar_top_15">
      <div class="flex Flexalign charts_top_left">
        <div class="study_long">学习时长（分钟）</div>
        <div class="study_suggest mar_left_10">每天建议学习时长：25分钟</div>
      </div>
      <div class="flex Flexalign charts_top_right">
        <el-select v-model="yearValue" placeholder="Select" size="large" style="width: 110px; height: 32px"
          @change="changeYear">
          <el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="monthValue" placeholder="Select" size="large"
          style="width: 110px; height: 32px; margin-left: 20px" @change="changeMonth">
          <el-option v-for="item in monthOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
    </div>
    <div class="charts_box">
      <studyDurationLineCharts ref="studyDurationLineCharts"></studyDurationLineCharts>
    </div>
  </div>
</template>

<script>
import studyDurationLineCharts from "@/components/echarts/studyDurationLineCharts.vue";
export default {
  name: "GjkcH5StudyHabits",
  components: {
    studyDurationLineCharts,
  },
  props: {
    courseDetail: {}
  },

  data() {
    return {
      yearOptions: [],
      yearValue: 2024,
      monthOptions: [],
      monthValue: 10,
      monthLearningList:[],
      monthDay:0,
      learnedDay:0,
    };
  },

  mounted() {
    this.getMonthOptions();
    this.getYearOptions();
    this.yearValue = new Date().getFullYear();
    this.monthValue = new Date().getMonth() + 1;
    this.statisticsListForDay();
    this.monthDay = this.$Moment().daysInMonth();
  },

  methods: {
    getMonthOptions() {
      for (let i = 1; i < 13; i++) {
        this.monthOptions.push({ label: i + "月", value: i });
      }
    },
    getYearOptions() {
      for (let i = 1959; i < 2099; i++) {
        this.yearOptions.push({ label: i + "年", value: i });
      }
    },
    changeYear() {
      this.statisticsListForDay();
    },
    changeMonth() {
      this.statisticsListForDay();
    },
    // 获取一个月的学习统计数据
    statisticsListForDay() {
      this.learnedDay = 0;
      let monthStartDate = this.yearValue + "-" + this.monthValue + "-01" + " 00:00:00";
      let monthEndDate = this.$Moment(monthStartDate).endOf('month').format("YYYY-MM-DD") + " 23:59:59";
      this.$Api.learning.statisticsListForDay({ beginTime: monthStartDate, endTime: monthEndDate, courseId: this.courseDetail.courseId }).then(res => {
        let dateList = res.data.data.map(item => {
          return this.$Moment(item.date).format("MM.DD")
        })
        let dataList = res.data.data.map(item => {
          return this.$Tools.secondToMinute(item.totalSeconds)
        })
        this.monthLearningList = res.data.data;
        this.monthLearningList.forEach(item=>{
          if(item.totalSeconds != 0){
            this.learnedDay++;
          }
        })
        this.$refs.studyDurationLineCharts.initCharts(dateList, dataList);
      }).catch(() => { })
    }
  },
};
</script>

<style lang="scss" scoped>
.progress_box {
  .progress_one {
    width: 280px;
    height: 88px;
    background: rgba(238, 250, 248, 0.6);
    border-radius: 10px;
    padding: 15px 20px;
    box-sizing: border-box;

    .study_text {
      color: #333333;
      font-weight: bold;
    }

    .study_days {
      width: 100%;
      text-align: end;
      color: #333333;
      font-weight: bold;

      .days_value {
        font-size: 30px;
        color: #13d6aa;
      }
    }
  }
}

.charts_top {
  .charts_top_left {
    .study_long {
      color: #333333;
      font-weight: 600;
    }

    .study_suggest {
      font-size: 14px;
      color: #13d6aa;
    }
  }
}

.charts_box {
  width: 100%;
  height: 300px;
}

:deep(.el-select__wrapper.is-focused) {
  box-shadow: none;
}

:deep(.el-select__wrapper) {
  box-shadow: none;
  border: none;
  background: #f5f8fb;
}

:deep(.el-select__placeholder) {
  color: #666666;
}

:deep(.el-select__caret) {
  color: #666666;
}
</style>
